import { Injectable } from '@angular/core';
import {DataService} from '../services';
import {AppConfig} from '../_config';
import { CanActivate,Router
          } from '@angular/router';

@Injectable()
export class EmailCheckGuard implements CanActivate {
  constructor(public router: Router,private appConfig:AppConfig) {}

  canActivate(): boolean {   
      if(this.appConfig.testingMode || DataService.get('emailAddress')){
        
        return true;
      }
      else{
        this.router.navigate(['/accountOpening']);
          return false;
      }
    
  }
}